import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import "./LayoutWizardServiceproviderDialog.scss";
import Login from "@/views/Login/Login.vue";

export default {
  name: "LayoutWizardServiceproviderDialog",
  components: { Login },
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    needLogin: false,
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    password: "",
    isRequired: [v => !!v || "Feld bitte ausfüllen"],
    editedItem: {},
    loading: false,
    panel: [0, 1]
  }),
  props: ["dialog", "config"],
  event: ["afterSave", "createError"],
  computed: {
    formTitle() {
      return this.editedItem.isNew
        ? "Leistungsträger anlegen"
        : "Leistungsträger bearbeiten";
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  methods: {
    fillData(data) {
      this.editedItem = data;
      this.createMissingProperties(); //for "Weitere Daten"
      this.unsaved = JSON.stringify(this.editedItem, null, 2);
    },
    loadingStatus(status) {
      this.loading = status;
    },
    close() {
      const before = this.unsaved;
      const current = JSON.stringify(this.editedItem, null, 2);
      if (before === current) {
        this.$emit("close");
      } else {
        this.$confirm(
          `Wollen Sie wirklich Abbrechen? Alle Änderungen werden verworfen!`,
          confirmWarningConfig
        ).then(res => {
          if (res) {
            this.$emit("close");
          }
        });
      }
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        this.loadingStatus(true);
        try {
          success = this.editedItem.isNew
            ? await this.createSp()
            : await this.updateSp();
          if (success) {
            this.unsaved = JSON.stringify(this.editedItem, null, 2);
            this.$emit("afterSave", close);
          }
        } catch (ex) {
          //catch invalid token. open login-dialog
          if (ex.toString().indexOf("401") !== -1) {
            this.needLogin = true;
            this.loadingStatus(false);
            return;
          }
          this.$emit("createError", ex);
        }
        this.loadingStatus(false);
      } else {
        this.snackMessage(
          "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!",
          this.mainRed
        );
      }
    },
    snackMessage(...emitArgs) {
      //emit parent snackbar - child-snackbar seems unreliable
      this.$emit("snackMessage", ...emitArgs);
    },
    async updateSp() {
      if (this.password !== "") {
        this.editedItem.password = this.password;
      }
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.assistent_api_client_url}service_providers/${this.editedItem._id}`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async createSp() {
      this.editedItem.password = this.password;
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.assistent_api_client_url}service_providers`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    convertToSelectObject(object) {
      const objectArray = [];
      for (let key in object) {
        objectArray.push({ value: key, text: object[key] });
      }
      return objectArray;
    },
    createMissingProperties() {
      // "Weitere Daten"-fields are dynamically and sometimes need initialisation
      this.editedItem.data = this.editedItem.data ?? {};
      for (let x in this.config.sp_data_fields) {
        if (!(x in this.editedItem.data)) {
          this.editedItem.data[x] = "";
        }
      }
      //avoid template-problems with missing address or payment object
      this.editedItem.address = this.editedItem.address ?? {};
      this.editedItem.payment = this.editedItem.payment ?? {};
    }
  }
};
